/* Project-wide simple utilities */

// this is stupid, but JS doesn't have a decent deep copy method.
export function copy(src) {
  return JSON.parse(JSON.stringify(src));
}

export function isObject(obj) {
  return obj === Object(obj);
}

/**
 * For being able to serialize via JSON a structure with circular references,
 * in order to report the problem. (We should not have cirular references.)
 * Differs from source in that it notes which attrs are references.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
 */
export const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (key, value) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return `circular reference; object keys: ${Object.keys(value)}`;
      }
      seen.add(value);
    }
    return value;
  };
};

/* Replace all attributes in Object 'elt' with value from Object 'layer'.
 * Works recursively. If called not on object, returns 'layer'.
 * Returns copy of 'elt' with 'overlay' data inside.
 */
export function overlay(elt, layer) {
  if (isObject(elt)) {
    const newElt = copy(elt);
    Object.keys(layer).forEach((k) => {
      if (k in newElt) {
        newElt[k] = overlay(newElt[k], layer[k]);
      }
    });
    return newElt;
  }
  return layer;
}

/* Take a Vuex design and format it for sending to the server.
 * Setting readonly injects a 'readonly' attribute.
 * Setting 'copy' asks for a new copy of the design, so we clear the
 * existing designcode. This is implied by 'readonly'
 */
export function designSavePayload(design, product, readonly, makeCopy) {
  const ro = !!readonly; // make sure boolean
  const cp = !!makeCopy || ro;

  const designcode = !cp ? design.designcode : '';
  const designname = design.name ? design.name : 'Untitled Design';
  return {
    key: designcode,
    name: designname,
    product: product.id,
    readonly: ro,
    image: design.image.key,
    color: design.color || product.color,
    centerx: design.relativePosition.centerX,
    centery: design.relativePosition.centerY,
    relativew: design.relativePosition.width,
    relativeh: design.relativePosition.height,
    rotation: design.relativePosition.rotation,
  };
}
